import { MagnifyingGlassMinusIcon, MagnifyingGlassPlusIcon, ArrowUturnRightIcon } from '@heroicons/react/20/solid';
import { CodeBracketSquareIcon } from '@heroicons/react/24/outline';
import { useMemo, useState } from 'react';
import { TooltipV2 } from '@cimplico/components';

type ImageViewerProps = {
    src: string;
    alt: string;
};
function ImageViewer({ src, alt }: ImageViewerProps): JSX.Element {
    const [scale, setScale] = useState(1);
    const [rotate, setRotate] = useState(0);

    function zoom(direction: 'in' | 'out'): void {
        if (direction === 'in') {
            setScale(scale + 0.2);
        } else {
            if (scale > 0.5) {
                // Set a minimum zoom level to prevent disappearing
                setScale(scale - 0.2);
            }
        }
    }

    function rotateImage(): void {
        setRotate((rotate + 90) % 360);
    }

    const url = useMemo(() => {
        if (src.startsWith('http')) {
            return src;
        } else {
            return `data:image/png;base64,${src}`;
        }
    }, [src]);

    return (
        <>
            <div className="h-8 bg-white border-b flex items-center justify-center py-2 text-sm gap-4 w-full self-start">
                <TooltipV2 message="Reset zoom" delayMs={1000}>
                    <button onClick={(): void => setScale(0.8)} className="mt-1">
                        <CodeBracketSquareIcon className="h-5 w-5 text-gray-600 rotate-90" />
                    </button>
                </TooltipV2>
                <TooltipV2 message="Zoom in" delayMs={1000}>
                    <button onClick={(): void => zoom('in')} className="mt-1">
                        <MagnifyingGlassPlusIcon className="h-5 w-5 text-gray-600" />
                    </button>
                </TooltipV2>
                <TooltipV2 message="Zoom out" delayMs={1000}>
                    <button onClick={(): void => zoom('out')} className="mt-1">
                        <MagnifyingGlassMinusIcon className="h-5 w-5 text-gray-600" />
                    </button>
                </TooltipV2>
                <TooltipV2 message="Rotate clockwise" delayMs={1000}>
                    <button onClick={rotateImage} className="mt-1">
                        <ArrowUturnRightIcon className="h-5 w-5 text-gray-600" />
                    </button>
                </TooltipV2>
            </div>
            <div className="overflow-auto relative flex-1 flex items-center justify-center h-full w-full">
                <img
                    src={url}
                    alt={alt}
                    className="w-full absolute transition-transform origin-center"
                    style={{ transform: `scale(${scale})`, rotate: `${rotate}deg` }}
                />
            </div>
        </>
    );
}

export default ImageViewer;
